import React from 'react';
import ICredits from '../@types/ICredits';

const maristaCredits: ICredits[] = [
  { role: 'Diretor-presidente', names: 'Ir. Vanderlei Siqueira' },
  { role: 'Vice-presidente', names: 'Ir. Délcio Afonso Balestrin' },
  { role: 'Diretor-superintendente', names: 'Mauricio Zanforlin' },
];

const cdmiCredits: ICredits[] = [
  { role: 'Diretor', names: 'Ir. Anacleto Peruzzo' },
  { role: 'Gerente', names: 'Bárbara Pimpão' },
  { role: 'Equipe técnica', names: 'Cecília Landarin Heleno, Débora Reis, Karoline Dutra Szul, Mariane Lins' },
  { role: 'Administrativo', names: 'Jaqueline Verneque' },
  { role: 'Comunicação', names: 'Milena Cristina Alves, Rafael Rodrigo Teixeira' },
  { role: 'Adaptação de conteúdo', names: 'Bárbara Pimpão, Cecília Landarin Heleno, Karoline Dutra Szul, Rafael Rodrigo Teixeira' },
];

const ftdCredits: ICredits[] = [
  { role: 'Diretor-geral', names: 'Ricardo Tavares de Oliveira' },
  { role: 'Diretora de inovação, plataformas e avaliação educacional', names: 'Ceciliany Alves Feitosa' },
  { role: 'Diretor de conteúdo e negócios', names: 'Cayube Galas' },
  { role: 'Diretora-adjunta de soluções didáticas e suplementares', names: 'Ana Carolina Costa Lopes' },
  { role: 'Gerente de conteúdo', names: 'Renata Lara de Moraes' },
  { role: 'Editor', names: 'Thiago Coutinho-Silva' },
  { role: 'Editoras-assistentes', names: 'Amanda Lenharo, Gislene Rodrigues' },
  { role: 'Coordenadora de produção editorial', names: 'Beatriz Mendes Yamazaki' },
  { role: 'Supervisora de revisão e qualidade', names: 'Giselle Bianca Mussi de Moura' },
  { role: 'Revisoras de texto', names: 'Bianca Oliveira, Tatiana Jaworski' },
  { role: (
    <>
      Supervisora de arte e
      {' '}
      <em>design</em>
    </>),
names: 'Simone Oliveira Vieira' },
  { role: 'Analistas de fluxo', names: 'Janaína Simplicio, Tayná Mendes da Silva' },
  { role: 'Supervisora de arquivos', names: 'Silvia Regina E. Almeida' },
  { role: 'Gerente de conteúdo digital', names: 'Letícia Mendes de Souza' },
  {
    role: 'Coordenadora de produção digital e audiovisual',
    names: 'Fernanda de Lima Bernardes'
  },
  {
    role: 'Analista de soluções digitais',
    names: 'Lívia Maria A. Stevaux'
  },
  {
    role: (
      <>
        <em>Designers</em>
        {' '}
        de soluções digitais
      </>
    ),
    names: 'Douglas Abade e Marina Martins'
  },
  {
    role: 'Coordenadora de projeto e conteúdo digital',
    names: 'Gisele Meleiro Rodrigues'
  },
  {
    role: 'Editores de conteúdo digital',
    names: 'Felipe Moreira, Fernanda Ramos de Andrade e Ramon Santana Domingues'
  },
  {
    role: 'Coordenadora de dados e publicação',
    names: 'Fernanda de Lima Bernardes'
  },
  { role: 'Supervisora de publicação digital', names: 'Sid Viana' },
  { role: 'Analista de publicação digital', names: 'Juliana Santos' },
  {
    role: (
      <>
        Coordenadora de qualidade de
        {' '}
        <em>software</em>
      </>
    ),
    names: 'Kelly Pereira Costa'
  },
  {
    role: (
      <>
        Analista de Qualidade de
        {' '}
        <em>software</em>
      </>
    ),
    names: 'Thays Martins Oyakawa'
  },
  {
    role: 'Participaram desta edição: ',
    names: (
      <>
        Maira Luana Moraes, Vania Alves Gonçalves Pupo (assistentes editoriais);
        Digital: analistas de produção digital, desenvolvedores
        {' '}
        <em>front-end</em>
        ,
        {' '}
        <em>scrum masters</em>
        , assistentes de produção digital,
        analistas de publicação digital e analistas de testes.
      </>
    )
  }
];

const additonalInfo: React.ReactNode = (
  <>
    <h3>Conteúdo base cuja adaptação foi autorizada para este projeto:</h3>
    <p>Alessandra Martins de Faria</p>
  </>
);

const disclaimer: React.ReactNode = (
  <>
    <p>
      As imagens utilizadas neste material que, eventualmente,
      reproduzam algum tipo de material de publicidade ou propaganda,
      ou a ele façam alusão, são aplicadas para fins didáticos
      e não representam recomendação ou incentivo ao consumo.
    </p>
  </>

);

export {
  maristaCredits,
  cdmiCredits,
  ftdCredits,
  additonalInfo,
  disclaimer,
};
